import { render, staticRenderFns } from "./ResolveInfectionCase.vue?vue&type=template&id=c0a50ea0&"
import script from "./ResolveInfectionCase.vue?vue&type=script&lang=js&"
export * from "./ResolveInfectionCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports